<h6 class="mt-3 m-2">Users</h6>

<era-pane>
  <div class="list-group list-group-flush">
    @for (user of users(); track user) {
      <div class="list-group-item d-flex">
        <span class="flex-grow-1">
          <h6>{{ user.displayName }}</h6>
          <p class="mb-0 lh-1">
            <small>Email: {{ user.email || 'No Email' }}</small><br />
          </p>
        </span>
        @if (isEditing()) {
          <button type="button"
                  class="btn btn-sm btn-outline-danger border-0"
                  (click)="delete(user)">
            <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
          </button>
        }
      </div>
    }
  </div>

  @if (users()?.length === 0) {
    <p class="mb-0">
      <span>No users configured.</span>
    </p>
  }
</era-pane>